/** Full-screen or inline "Загрузка…" */
export function LoadingBlock({ inline }) {
  const className = inline ? "pill" : "index-loading";
  return <div className={className}>Загрузка…</div>;
}
